/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as RemindersRouteImport } from './routes/reminders'
import { Route as LoginRouteImport } from './routes/login'
import { Route as InvoicesRouteImport } from './routes/invoices'
import { Route as ExportRouteImport } from './routes/export'
import { Route as EstimatesRouteImport } from './routes/estimates'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as CustomersRouteImport } from './routes/customers'
import { Route as ContractsRouteImport } from './routes/contracts'
import { Route as AuditLogRouteImport } from './routes/audit-log'
import { Route as IndexRouteImport } from './routes/index'
import { Route as InvoicesNewRouteImport } from './routes/invoices_.new'
import { Route as InvoicesIdRouteImport } from './routes/invoices_.$id'
import { Route as EstimatesNewRouteImport } from './routes/estimates_.new'
import { Route as EstimatesIdRouteImport } from './routes/estimates_.$id'
import { Route as CustomersNewRouteImport } from './routes/customers_.new'
import { Route as CustomersIdRouteImport } from './routes/customers_.$id'
import { Route as ContractsNewRouteImport } from './routes/contracts_.new'
import { Route as ContractsIdRouteImport } from './routes/contracts_.$id'
import { Route as InvoicesIdEditRouteImport } from './routes/invoices_.$id_.edit'

const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const RemindersRoute = RemindersRouteImport.update({
  id: '/reminders',
  path: '/reminders',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const InvoicesRoute = InvoicesRouteImport.update({
  id: '/invoices',
  path: '/invoices',
  getParentRoute: () => rootRouteImport,
} as any)
const ExportRoute = ExportRouteImport.update({
  id: '/export',
  path: '/export',
  getParentRoute: () => rootRouteImport,
} as any)
const EstimatesRoute = EstimatesRouteImport.update({
  id: '/estimates',
  path: '/estimates',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomersRoute = CustomersRouteImport.update({
  id: '/customers',
  path: '/customers',
  getParentRoute: () => rootRouteImport,
} as any)
const ContractsRoute = ContractsRouteImport.update({
  id: '/contracts',
  path: '/contracts',
  getParentRoute: () => rootRouteImport,
} as any)
const AuditLogRoute = AuditLogRouteImport.update({
  id: '/audit-log',
  path: '/audit-log',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const InvoicesNewRoute = InvoicesNewRouteImport.update({
  id: '/invoices_/new',
  path: '/invoices/new',
  getParentRoute: () => rootRouteImport,
} as any)
const InvoicesIdRoute = InvoicesIdRouteImport.update({
  id: '/invoices_/$id',
  path: '/invoices/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const EstimatesNewRoute = EstimatesNewRouteImport.update({
  id: '/estimates_/new',
  path: '/estimates/new',
  getParentRoute: () => rootRouteImport,
} as any)
const EstimatesIdRoute = EstimatesIdRouteImport.update({
  id: '/estimates_/$id',
  path: '/estimates/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomersNewRoute = CustomersNewRouteImport.update({
  id: '/customers_/new',
  path: '/customers/new',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomersIdRoute = CustomersIdRouteImport.update({
  id: '/customers_/$id',
  path: '/customers/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const ContractsNewRoute = ContractsNewRouteImport.update({
  id: '/contracts_/new',
  path: '/contracts/new',
  getParentRoute: () => rootRouteImport,
} as any)
const ContractsIdRoute = ContractsIdRouteImport.update({
  id: '/contracts_/$id',
  path: '/contracts/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const InvoicesIdEditRoute = InvoicesIdEditRouteImport.update({
  id: '/invoices_/$id_/edit',
  path: '/invoices/$id/edit',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/audit-log': typeof AuditLogRoute
  '/contracts': typeof ContractsRoute
  '/customers': typeof CustomersRoute
  '/dashboard': typeof DashboardRoute
  '/estimates': typeof EstimatesRoute
  '/export': typeof ExportRoute
  '/invoices': typeof InvoicesRoute
  '/login': typeof LoginRoute
  '/reminders': typeof RemindersRoute
  '/settings': typeof SettingsRoute
  '/contracts/$id': typeof ContractsIdRoute
  '/contracts/new': typeof ContractsNewRoute
  '/customers/$id': typeof CustomersIdRoute
  '/customers/new': typeof CustomersNewRoute
  '/estimates/$id': typeof EstimatesIdRoute
  '/estimates/new': typeof EstimatesNewRoute
  '/invoices/$id': typeof InvoicesIdRoute
  '/invoices/new': typeof InvoicesNewRoute
  '/invoices/$id/edit': typeof InvoicesIdEditRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/audit-log': typeof AuditLogRoute
  '/contracts': typeof ContractsRoute
  '/customers': typeof CustomersRoute
  '/dashboard': typeof DashboardRoute
  '/estimates': typeof EstimatesRoute
  '/export': typeof ExportRoute
  '/invoices': typeof InvoicesRoute
  '/login': typeof LoginRoute
  '/reminders': typeof RemindersRoute
  '/settings': typeof SettingsRoute
  '/contracts/$id': typeof ContractsIdRoute
  '/contracts/new': typeof ContractsNewRoute
  '/customers/$id': typeof CustomersIdRoute
  '/customers/new': typeof CustomersNewRoute
  '/estimates/$id': typeof EstimatesIdRoute
  '/estimates/new': typeof EstimatesNewRoute
  '/invoices/$id': typeof InvoicesIdRoute
  '/invoices/new': typeof InvoicesNewRoute
  '/invoices/$id/edit': typeof InvoicesIdEditRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/audit-log': typeof AuditLogRoute
  '/contracts': typeof ContractsRoute
  '/customers': typeof CustomersRoute
  '/dashboard': typeof DashboardRoute
  '/estimates': typeof EstimatesRoute
  '/export': typeof ExportRoute
  '/invoices': typeof InvoicesRoute
  '/login': typeof LoginRoute
  '/reminders': typeof RemindersRoute
  '/settings': typeof SettingsRoute
  '/contracts_/$id': typeof ContractsIdRoute
  '/contracts_/new': typeof ContractsNewRoute
  '/customers_/$id': typeof CustomersIdRoute
  '/customers_/new': typeof CustomersNewRoute
  '/estimates_/$id': typeof EstimatesIdRoute
  '/estimates_/new': typeof EstimatesNewRoute
  '/invoices_/$id': typeof InvoicesIdRoute
  '/invoices_/new': typeof InvoicesNewRoute
  '/invoices_/$id_/edit': typeof InvoicesIdEditRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/audit-log'
    | '/contracts'
    | '/customers'
    | '/dashboard'
    | '/estimates'
    | '/export'
    | '/invoices'
    | '/login'
    | '/reminders'
    | '/settings'
    | '/contracts/$id'
    | '/contracts/new'
    | '/customers/$id'
    | '/customers/new'
    | '/estimates/$id'
    | '/estimates/new'
    | '/invoices/$id'
    | '/invoices/new'
    | '/invoices/$id/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/audit-log'
    | '/contracts'
    | '/customers'
    | '/dashboard'
    | '/estimates'
    | '/export'
    | '/invoices'
    | '/login'
    | '/reminders'
    | '/settings'
    | '/contracts/$id'
    | '/contracts/new'
    | '/customers/$id'
    | '/customers/new'
    | '/estimates/$id'
    | '/estimates/new'
    | '/invoices/$id'
    | '/invoices/new'
    | '/invoices/$id/edit'
  id:
    | '__root__'
    | '/'
    | '/audit-log'
    | '/contracts'
    | '/customers'
    | '/dashboard'
    | '/estimates'
    | '/export'
    | '/invoices'
    | '/login'
    | '/reminders'
    | '/settings'
    | '/contracts_/$id'
    | '/contracts_/new'
    | '/customers_/$id'
    | '/customers_/new'
    | '/estimates_/$id'
    | '/estimates_/new'
    | '/invoices_/$id'
    | '/invoices_/new'
    | '/invoices_/$id_/edit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuditLogRoute: typeof AuditLogRoute
  ContractsRoute: typeof ContractsRoute
  CustomersRoute: typeof CustomersRoute
  DashboardRoute: typeof DashboardRoute
  EstimatesRoute: typeof EstimatesRoute
  ExportRoute: typeof ExportRoute
  InvoicesRoute: typeof InvoicesRoute
  LoginRoute: typeof LoginRoute
  RemindersRoute: typeof RemindersRoute
  SettingsRoute: typeof SettingsRoute
  ContractsIdRoute: typeof ContractsIdRoute
  ContractsNewRoute: typeof ContractsNewRoute
  CustomersIdRoute: typeof CustomersIdRoute
  CustomersNewRoute: typeof CustomersNewRoute
  EstimatesIdRoute: typeof EstimatesIdRoute
  EstimatesNewRoute: typeof EstimatesNewRoute
  InvoicesIdRoute: typeof InvoicesIdRoute
  InvoicesNewRoute: typeof InvoicesNewRoute
  InvoicesIdEditRoute: typeof InvoicesIdEditRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reminders': {
      id: '/reminders'
      path: '/reminders'
      fullPath: '/reminders'
      preLoaderRoute: typeof RemindersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoices': {
      id: '/invoices'
      path: '/invoices'
      fullPath: '/invoices'
      preLoaderRoute: typeof InvoicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/export': {
      id: '/export'
      path: '/export'
      fullPath: '/export'
      preLoaderRoute: typeof ExportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/estimates': {
      id: '/estimates'
      path: '/estimates'
      fullPath: '/estimates'
      preLoaderRoute: typeof EstimatesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customers': {
      id: '/customers'
      path: '/customers'
      fullPath: '/customers'
      preLoaderRoute: typeof CustomersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contracts': {
      id: '/contracts'
      path: '/contracts'
      fullPath: '/contracts'
      preLoaderRoute: typeof ContractsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/audit-log': {
      id: '/audit-log'
      path: '/audit-log'
      fullPath: '/audit-log'
      preLoaderRoute: typeof AuditLogRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoices_/new': {
      id: '/invoices_/new'
      path: '/invoices/new'
      fullPath: '/invoices/new'
      preLoaderRoute: typeof InvoicesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoices_/$id': {
      id: '/invoices_/$id'
      path: '/invoices/$id'
      fullPath: '/invoices/$id'
      preLoaderRoute: typeof InvoicesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/estimates_/new': {
      id: '/estimates_/new'
      path: '/estimates/new'
      fullPath: '/estimates/new'
      preLoaderRoute: typeof EstimatesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/estimates_/$id': {
      id: '/estimates_/$id'
      path: '/estimates/$id'
      fullPath: '/estimates/$id'
      preLoaderRoute: typeof EstimatesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customers_/new': {
      id: '/customers_/new'
      path: '/customers/new'
      fullPath: '/customers/new'
      preLoaderRoute: typeof CustomersNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customers_/$id': {
      id: '/customers_/$id'
      path: '/customers/$id'
      fullPath: '/customers/$id'
      preLoaderRoute: typeof CustomersIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contracts_/new': {
      id: '/contracts_/new'
      path: '/contracts/new'
      fullPath: '/contracts/new'
      preLoaderRoute: typeof ContractsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contracts_/$id': {
      id: '/contracts_/$id'
      path: '/contracts/$id'
      fullPath: '/contracts/$id'
      preLoaderRoute: typeof ContractsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoices_/$id_/edit': {
      id: '/invoices_/$id_/edit'
      path: '/invoices/$id/edit'
      fullPath: '/invoices/$id/edit'
      preLoaderRoute: typeof InvoicesIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuditLogRoute: AuditLogRoute,
  ContractsRoute: ContractsRoute,
  CustomersRoute: CustomersRoute,
  DashboardRoute: DashboardRoute,
  EstimatesRoute: EstimatesRoute,
  ExportRoute: ExportRoute,
  InvoicesRoute: InvoicesRoute,
  LoginRoute: LoginRoute,
  RemindersRoute: RemindersRoute,
  SettingsRoute: SettingsRoute,
  ContractsIdRoute: ContractsIdRoute,
  ContractsNewRoute: ContractsNewRoute,
  CustomersIdRoute: CustomersIdRoute,
  CustomersNewRoute: CustomersNewRoute,
  EstimatesIdRoute: EstimatesIdRoute,
  EstimatesNewRoute: EstimatesNewRoute,
  InvoicesIdRoute: InvoicesIdRoute,
  InvoicesNewRoute: InvoicesNewRoute,
  InvoicesIdEditRoute: InvoicesIdEditRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
